import MenuItem from './MenuItem'

const MenuList = ({ items, isMainMenuOpen, onClick }) => {
  return items.map((item, i) => (
    <MenuItem key={i} isMainMenuOpen={isMainMenuOpen} item={item} onClick={onClick(i)} />
  ))
}

export default MenuList
